import Flickity from '../flickity.pkgd.min.js';

export const CommunitySlider = {
    init() {
        var carousel = document.querySelector('.community-slider');
        var flkty = new Flickity(carousel, {
            contain: true,
            prevNextButtons: true,
            pageDots: false,
            cellAlign: centerSlider(),
            groupCells: true,
            cellSelector: '.community-card',
            // lazyLoad: true,
        });

        function centerSlider() {
            return matchMedia('screen and (max-width: 768px)').matches
                ? 'center'
                : 'left';
        }

        // Update cellAlign on window resize
        window.addEventListener('resize', function () {
            // flkty.cellAlign = getCellAlign();
            flkty.resize(); // Resize Flickity to update layout
        });

        // Function to set the tabindex for interactive elements within a given parent element
        function setTabindexOnChildren(element, value) {
            // Find interactive elements (a, button, input, textarea, select, .price-val, .ari-rating)
            // and set their tabindex attribute to the given value
            $(element)
                .find(
                    // 'div',
                    'a, button, input, textarea, select, .price-val, .ari-rating, .thumb-nail-slider'
                )
                // .not('.thumb-nail-slider')
                .attr('tabindex', value);
        }

        function updateTabIndex() {
            // Loop through each community card in the carousel and set tabindex to -1 (disable focus)
            $(carousel)
                .find('.community-card')
                .each(function () {
                    $(this).attr('tabindex', '-1'); // Disable focus on all cards
                    // setTimeout(() => {
                    setTabindexOnChildren(this, '-1'); // Disable focus on child elements
                    // }, 2000);
                });

            // For the selected community card, set tabindex to 0 (enable focus)
            $(carousel)
                .find('.community-card.is-selected')
                .each(function () {
                    $(this).attr('tabindex', '0'); // Enable focus on the selected card
                    // setTimeout(() => {
                    setTabindexOnChildren(this, '0'); // Enable focus on child elements of the selected card
                    // }, 2500);
                });
        }

        // Event listener for when an item is selected in the Flickity carousel
        flkty.on('select', function () {
            updateTabIndex();
            // Focus on the first selected community card
            var firstSelected = $(carousel)
                .find('.community-card.is-selected')
                .first();
            // if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            if (window.innerWidth > 1024) {
                firstSelected.focus(); // Set focus to the first selected card
            }
        });

        updateTabIndex();

        // $(document).on('focusin', function () {
        //     const focusedElement = document.activeElement;
        //     if ($(focusedElement).is(':focusable')) {
        //         console.log('Currently focused element:', focusedElement);
        //     }
        // });

        // $.extend($.expr[':'], {
        //     focusable: function (el) {
        //         return $(el).is(
        //             ':input, a[href], button, [tabindex]:not([tabindex="-1"])'
        //         );
        //     },
        // });
    },
};
